import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ACL_RELATIONSHIPS from "acl-relationships";
import { checkIsAuthorized } from "components/helpers";
import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import FormDialog from "components/modals/FormDialog";
import {
  deletePointOfContact,
  invalidatePointsOfContactQuery,
} from "hooks/usePointsOfContactTable";
import PointOfContactForm from "routes/points_of_contact/PointOfContactForm";

export function PointsOfContactTableActions({ original }) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const canEdit = checkIsAuthorized([ACL_RELATIONSHIPS.pointOfContact.edit]);
  const canDelete = checkIsAuthorized([
    ACL_RELATIONSHIPS.pointOfContact.delete,
  ]);

  const handleDelete = async () => {
    try {
      await deletePointOfContact(original.id);
      toast.success("Point of Contact deleted");
      setDeleteOpen(false);
    } catch {
      toast.error("Failed to delete Point of Contact");
    }
  };

  if (!canEdit && !canDelete) return null;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Point of Contact actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <FormDialog
        FormComponent={PointOfContactForm}
        model={original}
        modelType="Point of Contact"
        open={editOpen}
        onOpenChange={setEditOpen}
        onSuccess={invalidatePointsOfContactQuery}
      />
      <ConfirmDeleteDialog
        open={deleteOpen}
        onOpenChange={setDeleteOpen}
        title="Delete Point of Contact?"
        description="Are you sure you want to delete this Point of Contact?"
        onConfirm={handleDelete}
      />
    </>
  );
}
